import React, { FunctionComponent } from 'react';
import { Modal } from 'react-bootstrap';
import { IoMdClose } from 'react-icons/io';

import styled from 'styled-components';

interface ISuporteDialogContainer {}
const SuporteDialogContainer = styled.div`
    .frameStyle {
        width: 100%;
        height: 75%;
        border: none;
    }
`;

export const IFrameStyle = styled.iframe``;

export const SvgContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CloseButtonContainer = styled.div`
    padding: 0 0 10px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const CloseButton = styled.button`
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
`;

export const IFrameContainer = styled.div`
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;

    iframe {
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        position: absolute;
    }
`;

interface ISuporteDialog {
    showDialog: boolean;
    setShowDialog: (value: boolean) => void;
    iframeUrl: string;
}

const SuporteDialog: FunctionComponent<ISuporteDialog> = ({ showDialog = false, setShowDialog, iframeUrl }: ISuporteDialog) => {
    return (
        <SuporteDialogContainer>
            {showDialog && (
                <>
                    <Modal
                        show={showDialog}
                        onHide={() => {
                            setShowDialog(false);
                        }}
                        size="lg"
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body>
                            <CloseButtonContainer>
                                <CloseButton
                                    onClick={() => {
                                        setShowDialog(false);
                                    }}
                                >
                                    <IoMdClose />
                                </CloseButton>
                            </CloseButtonContainer>
                            <SvgContainer>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="130" viewBox="0 0 530.179 202.364">
                                        <path
                                            id="Caminho_1"
                                            data-name="Caminho_1 1143"
                                            d="M309.723,402.31h3.608V367.241l-3.608.3Zm-22.449-8.293c0,5.979,2.894,8.827,8.354,8.827a11.989,11.989,0,0,0,4.2-.715l-.3-2.843a8.791,8.791,0,0,1-2.959.473c-3.5,0-5.692-1.656-5.692-5.863V370.26h9.189v-2.908h-9.189v-9.531l-3.547.422v9.109h-5.511v2.908h5.45Zm-22.509,5.863a16.291,16.291,0,0,1-10.009-3.316l-.589,3.26c2.6,2.069,6.512,3.2,10.648,3.2,8.122,0,11.735-4.207,11.735-10.543,0-12.323-18.78-8-18.78-16.706,0-3.553,3.14-5.808,8.127-5.808a21.972,21.972,0,0,1,8.887,1.958l.347-3.14a20.6,20.6,0,0,0-9.188-2.013c-7.519,0-11.6,3.492-11.6,9.174,0,11.559,18.841,7.533,18.841,16.888,0,4.025-2.5,7.05-8.414,7.05m153.05,3.2c10.255,0,14.588-5.1,14.588-18.186,0-12.973-4.333-18.126-14.588-18.126-10.125,0-14.735,5.153-14.735,18.126,0,13.089,4.55,18.186,14.735,18.186m0-33.117c7.82,0,10.849,4.092,10.849,14.931,0,10.9-3.029,15.046-10.849,15.046-7.876,0-11.016-4.086-11.016-15.046,0-10.839,3.14-14.931,11.016-14.931M361.489,403.02c8.781,0,12.978-4.383,12.978-11.735V367.352h-3.558v23.817c0,5.515-3.255,8.414-9.42,8.414-6.149,0-9.35-2.964-9.35-8.414V367.352h-3.547v23.933c0,7.286,4.2,11.735,12.9,11.735m-49.924-42.648a2.521,2.521,0,1,0-2.522-2.516,2.51,2.51,0,0,0,2.522,2.516m74.346,33.645c0,5.979,2.883,8.827,8.333,8.827a12.215,12.215,0,0,0,4.232-.715l-.317-2.843a8.813,8.813,0,0,1-2.959.473c-3.492,0-5.7-1.656-5.7-5.863V370.26h9.189v-2.908H389.5v-9.531l-3.537.422v9.109h-5.51v2.908h5.455Zm-46.257,43.765h4.031v18.655c0,6.813,3.493,10.96,10.653,10.96a17.626,17.626,0,0,0,6.165-1l-.539-6.708a9.684,9.684,0,0,1-2.838.422c-2.848,0-4.267-1.187-4.267-3.97V437.782h8.006v-6.869h-8.006v-8.771l-8.771.78v7.991h-4.434Zm-11.206-43.765c0,5.979,2.893,8.827,8.343,8.827a11.863,11.863,0,0,0,4.2-.715l-.282-2.843a8.952,8.952,0,0,1-2.969.473c-3.487,0-5.681-1.656-5.681-5.863V370.26h9.179v-2.908h-9.179v-9.531l-3.563.422v9.109H323v2.908h5.45ZM204.821,402.31h3.558V357.876h-3.558Zm181.507,92.382a15.043,15.043,0,0,0-9.878,3.557v-3.18l-8.011.524v35.713h9.249V505.592a7.691,7.691,0,0,1,6.044-2.723c3.794,0,5.8,1.6,5.8,5.566v22.871h9.189V508.435c0-8.933-4.791-13.743-12.39-13.743m10.18-45.713c0-13.149-4.982-18.715-16.41-18.715-11.367,0-16.47,5.566-16.47,18.715,0,13.21,5.1,18.649,16.47,18.649,11.428,0,16.41-5.439,16.41-18.649m-23.349,0c0-8.771,1.847-11.141,6.939-11.141,5.043,0,6.874,2.37,6.874,11.141s-1.831,11.136-6.874,11.136c-5.027,0-6.939-2.319-6.939-11.136m38.27-7.88a7.685,7.685,0,0,1,6.054-2.728c3.784,0,5.792,1.61,5.792,5.566v22.876h9.188V443.937c0-8.942-4.8-13.733-12.384-13.733a14.966,14.966,0,0,0-9.888,3.548v-3.181l-8.011.519v35.723h9.249Zm-61.69,53.593a15.037,15.037,0,0,0-9.883,3.557v-3.18l-8,.524v35.713h9.24V505.592a7.68,7.68,0,0,1,6.038-2.723c3.8,0,5.818,1.6,5.818,5.566v22.871h9.163V508.435c0-8.933-4.785-13.743-12.374-13.743m68.448,0a31.143,31.143,0,0,0-12.324,2.375l.77,7.337a23.587,23.587,0,0,1,9.9-1.948c4.917,0,6.8,1.656,6.8,5.274V509.8a22.966,22.966,0,0,0-6.859-1c-8.187,0-12.812,4.549-12.812,11.192,0,8.056,4.338,11.906,11.141,11.906a12.353,12.353,0,0,0,9.718-4.091l.166.055v3.442h7.774V509.089c0-9.828-3.683-14.4-14.276-14.4m5.148,25.714c0,2.31-2.833,4.207-5.973,4.207-3.02,0-5.108-1.238-5.108-4.74,0-3.13,1.917-4.735,5.993-4.735a14.675,14.675,0,0,1,5.088.77ZM271.312,499.2c0-2.371,1.489-4.273,6.995-4.273a35.761,35.761,0,0,1,10.713,1.9l1.253-8.418a34.453,34.453,0,0,0-12.434-2.3c-11.267,0-16.123,6.094-16.123,13.617,0,14.865,20.445,11.916,20.445,18.906,0,3.07-2.143,4.846-7,4.846a25.963,25.963,0,0,1-12.319-3.251l-1.294,8.59a29.084,29.084,0,0,0,13.733,3.321c10.382,0,16.471-5.394,16.471-14.16,0-15.057-20.441-11.851-20.441-18.78M241.959,378.734V402.31H245.5V378.674c0-8.057-4.494-11.906-11.9-11.906a13.87,13.87,0,0,0-10.432,4.428v-4.1l-3.553.317V402.31h3.553V374.945c1.962-3.079,6.109-4.745,9.541-4.745,5.933,0,9.244,2.546,9.244,8.534m33.132,88.079-15.524-44.434h-11.9l-15.344,44.434h10.538l2.486-8.65h16.123l2.486,8.65ZM247.786,449.8l5.692-19.9h.181l5.45,19.9Zm63.572,44.953c-10.784,0-15.826,6.7-15.826,18.126,0,12.56,5.52,19.072,17.9,19.072a29.442,29.442,0,0,0,11.73-2.3l-1.007-7.407a26.2,26.2,0,0,1-9.6,1.766c-6.155,0-9.068-2.239-9.536-8.232h20.909a34.317,34.317,0,0,0,.236-4.328c0-11.368-5.636-16.7-14.81-16.7m-6.521,14.931c.422-5.219,2.143-7.3,6.582-7.3,3.849,0,6.224,2.013,6.34,7.3Zm31.184-78.845a13.9,13.9,0,0,0-3.915-.523c-4.081,0-7.578,2.133-9.838,6.456h-.181v-6.019l-.82.041-7.337.347v35.668h9.234V448.8c0-5.983,3.548-9.476,8.343-9.476a13.286,13.286,0,0,1,3.915.589Zm-26.711.07h-9.782l-5.863,21.8-1.132,4.62h-.176l-1.54-4.5L283,430.913H272.515l15.469,35.065-.192.473c-1.177,2.717-3.014,3.437-5.505,3.437a9.505,9.505,0,0,1-3.729-.775l-.7,6.527a15.586,15.586,0,0,0,6.1,1.122c6.154,0,10.361-2.964,13.028-10.251Z"
                                            transform="translate(-204.821 -343.461)"
                                            fill="#003c78"
                                        ></path>
                                        <g id="Grupo_3031" data-name="Grupo 3031" transform="translate(-375 -299)">
                                            <path
                                                id="Caminho_1142"
                                                data-name="Caminho 1142"
                                                d="M546.56,545.825c-1.291,0-31.816-.358-49.19-31.514l-.086-.156a137.02,137.02,0,0,1-15.575-46.442,115.229,115.229,0,0,1,23.525-86.907l.4-.474c.243-.288.487-.576.737-.859,20.231-22.885,51.021-36.012,84.475-36.012a127.613,127.613,0,0,1,44.8,8.134s1.134.416,1.722.647l.158.062c.608.237,1.216.474,1.822.722a141.9,141.9,0,0,1,38.1,22.433h.149l3.413,3.122a91.147,91.147,0,0,1,11.452,12.489,31.694,31.694,0,0,1,3.734,5.738l.236.481,35.892,93.728.192.886a97.335,97.335,0,0,1,1.966,13.4c.06.817.117,1.635.169,2.447.225,3.478.336,9.177.341,9.418l0,.228a28.46,28.46,0,0,1-28.428,28.427Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#fff"
                                            ></path>
                                            <path
                                                id="Caminho_1144"
                                                data-name="Caminho 1144"
                                                d="M696.559,429.756H623.98a34.649,34.649,0,0,0-.362,36.358H710.94C706.423,454.693,701.132,441.317,696.559,429.756Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#ffca00"
                                            ></path>
                                            <path
                                                id="Caminho_1145"
                                                data-name="Caminho 1145"
                                                d="M710.94,466.114H623.618a34.95,34.95,0,0,0,30,17.089h64c-.236-.641-.429-1.3-.68-1.932Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#003c78"
                                            ></path>
                                            <path
                                                id="Caminho_1146"
                                                data-name="Caminho 1146"
                                                d="M706.572,533.934A16.536,16.536,0,0,0,723.108,517.4s-.108-5.629-.318-8.878H507.755c14.173,25.415,38.8,25.415,38.8,25.415Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#ffca00"
                                            ></path>
                                            <path
                                                id="Caminho_1147"
                                                data-name="Caminho 1147"
                                                d="M722.629,506.181a85.214,85.214,0,0,0-1.728-11.758H653.615a46.26,46.26,0,0,1-42.584-28.309H493.493c1.762,12.991,6.088,27.219,14.263,42.4H722.79C722.74,507.741,722.686,506.959,722.629,506.181Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#003c78"
                                            ></path>
                                            <path
                                                id="Caminho_1148"
                                                data-name="Caminho 1148"
                                                d="M611.309,429.757H494.938a103.308,103.308,0,0,0-1.445,36.357H611.031a46.009,46.009,0,0,1,.278-36.357Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#ffca00"
                                            ></path>
                                            <path
                                                id="Caminho_1149"
                                                data-name="Caminho 1149"
                                                d="M641.792,387.351H672.98c-7.93-7.259-20.151-16.005-38.132-23.318-.609-.25-1.22-.486-1.83-.724-.517-.2-1.528-.573-1.528-.573-42.76-15.975-89.821-5.238-116.21,24.615Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#ffca00"
                                            ></path>
                                            <path
                                                id="Caminho_1150"
                                                data-name="Caminho 1150"
                                                d="M690.035,413.262h-36.42a34.945,34.945,0,0,0-29.635,16.494h72.579C694.1,423.528,691.848,417.846,690.035,413.262Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#22a538"
                                            ></path>
                                            <path
                                                id="Caminho_1151"
                                                data-name="Caminho 1151"
                                                d="M672.985,387.351H515.28c-.3.337-.582.683-.874,1.024a101.8,101.8,0,0,0-19.468,41.382H611.309a46.238,46.238,0,0,1,42.306-27.714h31.91a20.95,20.95,0,0,0-2.476-3.711A78.647,78.647,0,0,0,672.985,387.351Z"
                                                transform="translate(170.179 -44.461)"
                                                fill="#22a538"
                                            ></path>
                                        </g>
                                    </svg>
                                </div>
                            </SvgContainer>
                            <IFrameContainer>
                                <iframe src={iframeUrl} className="frameStyle"></iframe>
                            </IFrameContainer>
                        </Modal.Body>
                    </Modal>
                </>
            )}
        </SuporteDialogContainer>
    );
};

export default SuporteDialog;
